export function base64ToFile(data, filename = 'photo.png') {
  const arr = data.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export function convertFile(blob: Blob, filename = 'photo.png') {
  return new File([blob], filename, {
    type: blob?.type,
  });
}
